/** DTOs keys for "storage" module */
export enum StorageDtoKeyEnum {
  /** Bucket response body */
  BUCKET_FIND_DTO = 'storage/bucket-find.dto',
  /** File description response body */
  FILE_FIND_DTO = 'storage/file-find.dto',
  /** File upload API query parameters */
  FILE_UPLOAD_QUERY_DTO = 'storage/file-upload-query.dto',
  /** Storage commentary file response body */
  COMMENTARY_FILE_FIND_DTO = 'storage/commentary-file-find.dto',
}
